'use client';
import { type PropsWithChildren } from 'react';
import ReduxProvider from '@/providers/ReduxProvider';
import AppStateProvider from '@/providers/AppStateProvider';
import LoadedFilesProvider from '@/providers/LoadedFilesProvider';
import SocketsProvider from '@/providers/SocketsProvider';

export default function AppProviders({ children }: PropsWithChildren) {
  return (
    <ReduxProvider>
      <SocketsProvider>
        <AppStateProvider>
          <LoadedFilesProvider>{children}</LoadedFilesProvider>
        </AppStateProvider>
      </SocketsProvider>
    </ReduxProvider>
  );
}
